import { useEffect, useRef, useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Icon } from "./Icon";
import { Avatar } from "./Avatar";

export function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!menuOpen) return;
    const onClick = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) setMenuOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [menuOpen]);

  const onLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  const navClass = ({ isActive }: { isActive: boolean }) =>
    isActive ? "nav-link active" : "nav-link";

  return (
    <div className="app">
      <header className="app-header">
        <Link to="/board" className="brand">
          <span className="brand-mark">
            <Icon name="layers" size={18} />
          </span>
          <span className="brand-text">Ticket&nbsp;Tracker</span>
        </Link>

        <nav className="app-nav">
          <NavLink to="/board" className={navClass}>
            <Icon name="board" size={17} /> <span>Board</span>
          </NavLink>
          <NavLink to="/teams" className={navClass}>
            <Icon name="teams" size={17} /> <span>Teams</span>
          </NavLink>
          <NavLink to="/epics" className={navClass}>
            <Icon name="epics" size={17} /> <span>Epics</span>
          </NavLink>
        </nav>

        <div className="user-menu" ref={menuRef}>
          <button className="user-menu-trigger" onClick={() => setMenuOpen((o) => !o)}>
            <Avatar name={user?.email ?? "?"} small />
            <span className="u-email">{user?.email ?? "Account"}</span>
            <Icon name="chevronDown" size={16} />
          </button>
          {menuOpen && (
            <div className="user-menu-dropdown">
              <div className="user-menu-head">
                <Avatar name={user?.email ?? "?"} />
                <div className="grow">
                  <div className="u-email">{user?.email}</div>
                  <div className="mono">Signed in</div>
                </div>
              </div>
              <button className="menu-item danger" onClick={onLogout}>
                <Icon name="logout" size={17} /> Log out
              </button>
            </div>
          )}
        </div>
      </header>

      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
}
